import { BANNER_OFFSET_HEIGHT, BANNER_OFFSET_TOP } from '@common/components/dunning-banner/banner-offset';
import { BulkView, setActiveBulkView, setActiveTab, setCampaignIdForLogsView, BulkDashboardTab, duplicateCampaignThunk, editCampaignThunk } from "@common-reducers/CampaignReducer";
import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook";
import { useEffect } from "react";
import BTBulkDashboard from "./bt-bulk-dashboard";
import BTBulkManagement from "./bt-bulk-management";
import BulkLogsView from "./bulk-logs-view/bulk-logs-view";
import BulkTaskViewContainer from "./bulk-task-view-container";
import NewTemplateView from "./new-template-view";
import { useRestoreCampaignViewFromUrl } from "@common-views/launch-campaign-view/use-restore-campaign-view-from-url";
import { isCampaignManagementPath } from "@common/utils/campaign-routes";

export interface CampaignsViewProps {
    isWebsite?: boolean;
}

export default function CampaignsView({ isWebsite = false }: CampaignsViewProps) {
    const dispatch = useAppDispatch()
    const location = window.location.href

    const activeBulkView = useAppSelector((state) => state.CampaignReducer.activeBulkView);

    // Website-only: deep-link / refresh restores the tab and audience board from the URL.
    // No-op in the extension / WhatsApp view (the hook self-gates).
    useRestoreCampaignViewFromUrl();




    // Handle location changes
    useEffect(() => {
        if (location.includes('supportedUserId')) {
            dispatch(setActiveBulkView('campaignManagementView' as BulkView))
        }

        // Only clear state on unmount if we're definitely leaving the campaign context
        // Check if we're navigating to a non-campaign page
        return () => {
            const pathname = window.location.pathname;
            // Stay "within campaign area" for the new /manage-* and /audience tab paths too,
            // otherwise navigating between tabs would wrongly reset the view on unmount.
            const isNavigatingToCampaignPage = isCampaignManagementPath(pathname) ||
                                             pathname.includes('/campaigns');

            if (!isNavigatingToCampaignPage) {
                dispatch(setActiveBulkView('' as BulkView))
            }
        }
    }, [location, dispatch]);

    // Initialize view only once on mount if needed
    // Note: activeBulkView is intentionally not in deps to avoid infinite loops
    useEffect(() => {
        if (!activeBulkView || (activeBulkView as string) === '') {
            dispatch(setActiveBulkView('campaignManagementView' as BulkView))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Only run on mount

    // No longer needed - Redux store persists across navigation
    // State is set via dispatch before navigation, so it's already in the store

    // create a boolean flag that is true only if user.bulkVersion doesnt exist or  if user.bulkVersion exists and is not "migrated"
    // const isEnterMigrationEvent = !user?.bulkVersion || (user?.bulkVersion && user?.bulkVersion !== "migrated")

    return (
        <div style={{
            // Website renders inside AppView's content container (already 100vh - header),
            // so fill it (100%) to avoid overflowing and producing a page-level scrollbar.
            // The extension injects this as a full-screen overlay, so it keeps 100vh.
            height: isWebsite ? '100%' : BANNER_OFFSET_HEIGHT,
            marginTop: isWebsite ? undefined : BANNER_OFFSET_TOP,
            direction: 'ltr',
            backgroundColor: 'var(--color-bg)',
        }}>

            {
                (activeBulkView === "newCampaignView" || 
                 activeBulkView === "campaignNewAudienceFromManagementView" || 
                 activeBulkView === "campaignNewAudienceFromNewCampaignView"
                ) &&
                <BTBulkDashboard />
            }

            {
                activeBulkView === "campaignManagementView" &&
                <BTBulkManagement />
            }

            {
                (activeBulkView === "campaignBoardFromManagementView"
                    || activeBulkView === "campaignBoardFromNewCampaignView") &&
                <BulkTaskViewContainer />
            }

            {
                (activeBulkView === "campaignNewTemplateViewFromManagement"
                    || activeBulkView === "campaignNewTemplateViewFromNewCampaignView"
                    || activeBulkView === 'campaignNewTemplateViewFromWhatsappView') &&
                <NewTemplateView />
            }

            {
                (activeBulkView === "campaignLogsView") &&
                <BulkLogsView />
            }


        </div>
    )
}